import React from 'react'
import {
  IProps as IProductToursDemo,
  ProductToursDemo,
} from 'marketing-site/src/components/bespoke/product-tours/ProductToursDemo'
import { IProductToursDemo as IContentfulProductToursDemo } from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'

export const ContentfulProductToursDemo = (productToursDemo: IContentfulProductToursDemo) => (
  <EntryMarker entry={productToursDemo}>
    {() => <ProductToursDemo {...transformProductToursDemo(productToursDemo)} />}
  </EntryMarker>
)

export function transformProductToursDemo({
  fields,
}: IContentfulProductToursDemo): IProductToursDemo {
  return {
    ...fields,
  }
}
